'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxPersist = require('redux-persist');

var _reducers = require('./reducers');

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
// import persistState from 'redux-localstorage'

var store = (0, _redux.createStore)(_reducers2.default, (0, _reduxPersist.autoRehydrate)(), /* preloadedState, */composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk2.default)
// persistState()
));

var config = {
  keyPrefix: 'crossprint',
  whitelist: ['product', 'order'],
  storage: window.LocalStorage
};
(0, _reduxPersist.persistStore)(store, config);

exports.default = store;


//////////////////
// WEBPACK FOOTER
// ./src/js/store.js
// module id = 587
// module chunks = 0